import { Store } from '@medusajs/medusa'
import { StoreWithAverageRating } from 'stoux-shared-types/services/store'

import { StoreRepository, WithAverageRating } from '../repositories/store'
import axios from '@/core/axios'
import { z } from 'zod'

type InjectedDependencies = {
    storeRepository: StoreRepository
}

export const CreateStoreRatingSchema = z.object({
    storeId: z.string().min(1),
    rating: z.number().min(1).max(5),
    orderId: z.string().min(1),
    token: z.string().min(1),
})

export type CreateStoreRatingDto = z.infer<typeof CreateStoreRatingSchema>

export class StoreService {
    private readonly _storeRepository: StoreRepository

    constructor({ storeRepository }: InjectedDependencies) {
        this._storeRepository = storeRepository
    }

    async getStoreById(id: string): Promise<Store & WithAverageRating> {
        const store = await this._storeRepository.getById(id)
        return store
    }

    async list(): Promise<StoreWithAverageRating[]> {
        const stores = await this._storeRepository.list()
        return stores
    }

    async saveStoreRating(dto: CreateStoreRatingDto) {
        const { storeId, token, ...rest } = dto

        return await axios.post(`/ratings/${dto.storeId}`, rest, {
            params: {
                token,
            },
        })
    }
}
